import React from 'react';
import styles from './TipCard.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const TipCard = ({
  background,
  text,
  level,
}) => {
  return (
    <img className={cx('TipCard', `TipCard--${level}`)} src={background} alt={''}/>
  );
};

export default TipCard;


// WEBPACK FOOTER //
// ./src/app/intro/components/TipCard/TipCard.js